<div class="container">
  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiario.orgao.sigla }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="5"></app-etapas-beneficio>

  <h1 class="page-title">Deduções do Militar</h1>

  <mat-card class="tabela-card">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <table
      mat-table
      [dataSource]="deducoes"
      class="mat-elevation-z2"
      *ngIf="!loading"
    >
      <ng-container matColumnDef="motivoAfastamento">
        <th mat-header-cell *matHeaderCellDef>Motivo</th>
        <td mat-cell *matCellDef="let d">{{ d.motivoAfastamento }}</td>
      </ng-container>

      <ng-container matColumnDef="dscTipoAfastamento">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let d">{{ d.dscTipoAfastamento }}</td>
      </ng-container>

      <ng-container matColumnDef="datAfastamento">
        <th mat-header-cell *matHeaderCellDef>Data Afastamento</th>
        <td mat-cell *matCellDef="let d">
          {{ d.datAfastamento | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="datRetorno">
        <th mat-header-cell *matHeaderCellDef>Data Retorno</th>
        <td mat-cell *matCellDef="let d">
          {{ d.datRetorno | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="qtdTotalDias">
        <th mat-header-cell *matHeaderCellDef>Dias</th>
        <td mat-cell *matCellDef="let d">{{ d.qtdTotalDias ?? 'Não informado' }}</td>
      </ng-container>
      <ng-container matColumnDef="statusDoc">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let d">{{ d.statusDoc || (d.hashDoc ? 'Anexado' : (d.qtdDiasDeduzidos === 0 ? '—' : 'Ausente')) }}</td>
      </ng-container>
      <ng-container matColumnDef="qtdDiasDeduzidos">
        <th mat-header-cell *matHeaderCellDef>Dias Deduzidos</th>
        <td mat-cell *matCellDef="let d">{{ d.qtdDiasDeduzidos }}</td>
      </ng-container>

      <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let d">
<button mat-icon-button matTooltip="Detalhar e editar repasses" (click)="editarRepasses(d)"><mat-icon>payments</mat-icon></button>

          <!-- Upload -->
          <button
            mat-icon-button
            (click)="abrirModalUpload(d)"
            matTooltip="Anexar Documento"
          >
            <mat-icon color="primary">upload_file</mat-icon>
          </button>

          <!-- Download -->
          <button
            mat-icon-button
            (click)="downloadFile(d)"
            matTooltip="Baixar Documento"
            [disabled]="!(d.hashDoc || d.hash)"
          >
            <mat-icon>download</mat-icon>
          </button>

          <!-- Delete -->
          <button
            mat-icon-button
            (click)="deletarDocumento(d)"
            matTooltip="Excluir Documento"
            [disabled]="!(d.hashDoc || d.hash)"
          >
            <mat-icon color="warn">delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card>

  <div class="acoes-atualizacao">
    <button mat-flat-button color="primary" (click)="atualizarDados()" [disabled]="loading || atualizando">
      {{ atualizando ? 'Atualizando...' : 'Atualizar e Salvar Dados' }}
    </button>
  </div>

  <!-- Modal de Upload -->
  <ng-template #modalUpload let-data>
    <h2 mat-dialog-title>Anexar Documento</h2>
    <mat-dialog-content class="upload-content">
      <p><strong>Comprovação Dedução</strong></p>
      <p>Envie um arquivo PDF referente à dedução selecionada.</p>

      <div class="upload-row">
        <input
          type="file"
          accept="application/pdf"
          hidden
          #fileInput
          (change)="onFileSelected($event)"
        />
        <button mat-stroked-button color="primary" (click)="fileInput.click()">
          <mat-icon>attach_file</mat-icon>
          Procurar PDF
        </button>
        <span class="file-name" *ngIf="selectedFile">{{
          selectedFile.name
        }}</span>
      </div>

      <mat-progress-bar
        *ngIf="uploading"
        mode="indeterminate"
      ></mat-progress-bar>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
      <button mat-stroked-button mat-dialog-close [disabled]="uploading">
        <mat-icon>close</mat-icon> Cancelar
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="enviarDocumento()"
        [disabled]="!selectedFile || uploading"
      >
        <mat-icon>cloud_upload</mat-icon> Enviar
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
